import { CommonModule } from '@angular/common';
import { booleanAttribute, Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

export type InfoBannerVariant = 'info' | 'warning';

@Component({
  selector: 'app-info-banner',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './info-banner.component.html',
  styleUrl: './info-banner.component.scss',
})
export class InfoBannerComponent {
  message = input.required<string>();
  title = input<string>();
  ariaLabel = input<string>();
  variant = input<InfoBannerVariant>('info');
  iconUrl = input('/public/svgs/info.svg');
  compact = input(false, { transform: booleanAttribute });
  actionLabel = input<string>();
  translateTitle = input(false);
  translateMessage = input(false);
  translateAriaLabel = input(false);
  actionClick = output<void>();
}
